import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductLeftSidebarComponent } from './product/sidebar/product-left-sidebar/product-left-sidebar.component';
import { ProductRightSidebarComponent } from './product/sidebar/product-right-sidebar/product-right-sidebar.component';
import { ProductNoSidebarComponent } from './product/sidebar/product-no-sidebar/product-no-sidebar.component';
import { ThreeColumnComponent } from './product/three-column/three-column.component';
import { FourImageComponent } from './product/four-image/four-image.component';
import { BundleProductComponent } from './product/bundle-product/bundle-product.component';
import { ImageOutsideComponent } from './product/image-outside/image-outside.component';

import { CollectionLeftSidebarComponent } from './collection/collection-left-sidebar/collection-left-sidebar.component';
import { CollectionRightSidebarComponent } from './collection/collection-right-sidebar/collection-right-sidebar.component';
import { CollectionNoSidebarComponent } from './collection/collection-no-sidebar/collection-no-sidebar.component';
import { CollectionInfinitescrollComponent } from './collection/collection-infinitescroll/collection-infinitescroll.component';

import { CartComponent } from './cart/cart.component';
import { WishlistComponent } from './wishlist/wishlist.component';
import { CompareComponent } from './compare/compare.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { SuccessComponent } from './checkout/success/success.component';

import { BrandCollectionByIdResolver, BrandCollectionResolver, DinarCurrencyResolver, MarketsResolver, orderByIdResolver, Resolver, shippingByIdResolver, WishlistResolver } from '../shared/services/resolverRequests.resolver';
import { USACollectionComponent } from './collection/usa-collection/usa-collection.component';
import { AuthGuard } from '../shared/guards/auth-guard.guard';
import { LoginGuard } from '../shared/guards/login.guard';
import { MarketProductComponent } from './online/marketProduct/marketProduct.component';
import { OnlineMarketComponent } from './online/onlineMarket/onlineMarket.component';
import { ShippingDetailsComponent } from './online/ShippingDetails/ShippingDetails.component';
import { USAMarketsComponent } from './online/USA-Markets/USA-Markets.component';
import { WholesaleAccountLoginComponent } from './online/wholesaleAccountLogin/wholesaleAccountLogin.component';
import { MarketComponent } from './online/market/Market.component';

const routes: Routes = [
  {
    path: 'market',
    component: MarketProductComponent
  },
  {
    path: 'shippingOrder',
    component: USAMarketsComponent
  },
  {
    path: 'onlineMarket',
    component: OnlineMarketComponent,
    resolve: {
      marketList: MarketsResolver
    },
    canActivate: [LoginGuard],

  },
  {
    path: 'usaMarkets',
    component: USAMarketsComponent,
    resolve: {
      marketList: MarketsResolver
    }

  },
  {
    path: 'onlineMarket/:buyerId/:shippingId',
    component: ShippingDetailsComponent,
    canActivate: [LoginGuard],
    resolve: {
      shippingByIdResolver: shippingByIdResolver
    }

  },
  {
    // path: 'product/:slug',
    path: 'product',
    component: USACollectionComponent,
    // resolve: {
    //   brandCollectionResolver: BrandCollectionResolver
    // },
    // data: { params: { currentPage: 1, pageSize: 24 } }
  },
  {
    path: 'product/left/sidebar/:barcode',
    component: ProductLeftSidebarComponent,
    resolve: {
      brandCollectionByIdResolver: BrandCollectionByIdResolver
    }
  },
  {
    path: 'product/right/sidebar/:barcode',
    component: ProductRightSidebarComponent,
    resolve: {
      data: Resolver
    }
  },
  {
    path: 'product/no/sidebar/:barcode',
    component: ProductNoSidebarComponent,
    resolve: {
      data: Resolver
    }
  },
  {
    path: 'product/three/column/:barcode',
    component: ThreeColumnComponent,
    resolve: {
      data: Resolver
    }
  },
  {
    path: 'product/four/image/:barcode',
    component: FourImageComponent,
    resolve: {
      data: Resolver
    }
  },
  {
    path: 'product/bundle/:slug',
    component: BundleProductComponent,
    resolve: {
      data: Resolver
    }
  },
  {
    path: 'product/image/outside/:slug',
    component: ImageOutsideComponent,
    resolve: {
      data: Resolver
    }
  },
  {
    path: 'collection/left/sidebar',
    component: CollectionLeftSidebarComponent
  },
  {
    path: 'collection/right/sidebar',
    component: CollectionRightSidebarComponent
  },
  {
    path: 'collection/no/sidebar',
    component: CollectionNoSidebarComponent
  },
  {
    path: 'collection/infinitescroll',
    component: CollectionInfinitescrollComponent
  },
  {
    path: 'cart',
    component: CartComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'wishlist',
    component: WishlistComponent,
    resolve: {
      Wishlist: WishlistResolver

    }
  },
  {
    path: 'compare',
    component: CompareComponent
  },
  {
    path: 'checkout',
    component: CheckoutComponent,
    canActivate: [LoginGuard],
    resolve: {
      dinarCurrencyResolver: DinarCurrencyResolver
    }
  },
  {
    path: 'checkout/success/:orderId',
    component: SuccessComponent,
    // resolve: {
    //   orderByIdResolver: orderByIdResolver
    // }
  },
  {
    path: 'wholesaleLogin',
    component: WholesaleAccountLoginComponent
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule { }
